import api from "./api";
import dayjs from "dayjs";

export const getAvailabilityByDate = async (date) => {
  const { data } = await api.get(`/availability/${date}`);
  return data;
};

export const getAvailabilityForMonth = async (year, month) => {
  const start = dayjs(`${year}-${month}-01`)
    .startOf("month")
    .format("YYYY-MM-DD");
  const end = dayjs(start).endOf("month").format("YYYY-MM-DD");
  const promises = [];

  for (let i = 0; i < dayjs(end).date(); i++) {
    const date = dayjs(start).add(i, "day").format("YYYY-MM-DD");
    promises.push(getAvailabilityByDate(date));
  }

  const results = await Promise.all(promises);
  return results.reduce((acc, day) => {
    acc[day.date] = day.slots.filter((s) => s.remaining > 0).length;
    return acc;
  }, {});
};
